var $cfcfda392bc6483e$exports = {};
$cfcfda392bc6483e$exports = {
  "collapse": "Zwi\u0144",
  "expand": "Rozwi\u0144"
};
export { $cfcfda392bc6483e$exports as default };